export const CREATE_UNIT_EXPENSE_RECORD = "CREATE_UNIT_EXPENSE_RECORD";
export const FETCH_UNIT_EXPENSE_RECORDS = "FETCH_UNIT_EXPENSE_RECORDS";
export const FETCH_UNIT_EXPENSE_RECORD = "FETCH_UNIT_EXPENSE_RECORD";
export const EDIT_UNIT_EXPENSE_RECORD = "EDIT_UNIT_EXPENSE_RECORD";
export const DELETE_UNIT_EXPENSE_RECORD = "DELETE_UNIT_EXPENSE_RECORD";
